import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { DashboardFacade } from './dashboard.facade';
import { MyFamilyGroupFacade } from './dashboard-my-family-group/my-family-group.facade';


@Component({
  selector: 'nobis-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private router = inject(Router)
  private facade = inject(DashboardFacade);
  private facadeMyFamilyGroup= inject(MyFamilyGroupFacade)
  private store = inject(Store)
  private destroy$ = new Subject<void>();


  public ngOnInit(): void {
    this.facade.isAuthenticated
      .pipe(finalize(() => this.router.navigateByUrl('login')))
      .subscribe();
    this.facade.dispatchAuthorizations(0)
    this.facadeMyFamilyGroup.dispachFamilyGroup();
    this.facade.dispatchUnreadCount();
    // Solo registra si el afiliado ya había concedido el permiso: no muestra el diálogo del navegador.
    this.facade.registerPush();
    this.facade.foregroundPush$
      .pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        this.facade.dispatchPushReceived();
        this.facade.showPushNotification(payload);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



